export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11810.9a55c0ff.jpg";